import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import clsx from 'clsx';
import _ from 'lodash';

function SelectBoxComponent(props) {
  const {
    labelName,
    required,
    optionList,
    placeholder,
    defaultValue,
    filterAction,
    disabled,
    inputProps,
    formWrapperPadding,
    showSelectOne = true,
    onOpen,
    onClose,
  } = props;
  return (
    <fieldset className={clsx('selectBoxArea custom-fieldset')}>
      <legend className='same-font-family'>
        {labelName} <span className='mandatory'>{required ? '*' : ''}</span>
      </legend>
      <div className={formWrapperPadding ? 'py-3 my-1' : 'form-wrapper db'}>
        <div className='with-select rmv_border'>
          <TextField
            id={labelName ? _.kebabCase(labelName) : ''}
            label={labelName}
            className='frr-display-hidden-label frr-remove-formClt-mt8-label'
            data-testid='rebate-program-select-box'
            fullWidth
            required={required || false}
            select
            disabled={disabled || false}
            placeholder={placeholder}
            inputProps={
              inputProps
                ? {
                    ...inputProps,
                    'aria-hidden': false,
                    id: labelName ? _.kebabCase(labelName) : '',
                  }
                : {
                    maxlength: 20,
                    'aria-hidden': false,
                    id: labelName ? _.kebabCase(labelName) : '',
                  }
            }
            InputLabelProps={{ shrink: true }}
            value={defaultValue}
            onChange={(e) => filterAction(e.target.value)}
            SelectProps={{
              onOpen: onOpen,
              onClose: onClose,
              MenuProps: {
                disableAutoFocusItem: false,
                autoFocus: true,
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                PaperProps: {
                  style: {
                    zIndex: 9999,
                  },
                },
                MenuListProps: {
                  // autoFocus: true,
                  tabIndex: -1,
                },
              },
            }}
          >
            {showSelectOne && (
              <MenuItem key='' value='-1' className='frr-dropdown-blank-item' />
            )}
            {!_.isEmpty(optionList)
              ? optionList?.map((item) => (
                  <MenuItem key={item.id} value={item.id}className="frr-logcheck-dropdown-item"
                classes={{
                  root: 'frr-menu-item-root',
                  selected: 'frr-menu-item-selected'
                }}>
                    {item.name}
                  </MenuItem>
                ))
              : null}
          </TextField>
        </div>
      </div>
    </fieldset>
  );
}

export default SelectBoxComponent;
